import $http from '../../axios';
import {Notification} from 'element-ui';

export async function fetchUsers({commit, state}) {
    if (!state.users.length) {
        await $http.get('/api/usuarios-por-rol')
            .then((response) => {
                commit('setUsers', response.data.data);
            })
            .catch((error) => {
                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box',
                });
            });
    }
}

export async function fetchLeaderships({commit, state}) {

    let parameters = {
        params: state.params
    };

    await $http.get('/api/jefaturas', parameters)
        .then((response) => {
            commit('setLeaderships', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });

}

export async function addLeadership({commit, state}) {
    await $http.post('/api/jefaturas', state.selectedLeadership)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'La Jefatura ha sido creado',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box',
            });
            commit('resetSelectedLeadership');
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        });
}

export async function updateLeadership({commit, state}) {
    await $http.put('/api/jefaturas/' + state.selectedLeadership.id, state.selectedLeadership)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'El Usuario ha sido actualizado',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        });
}

export async function deleteLeadership({commit, state, dispatch}, id) {
    await $http.delete('/api/jefaturas/' + id)
        .then(async (response) => {
            await dispatch('fetchLeaderships')
            Notification.success({
                title: 'Éxito!',
                message: 'Jefatura eliminada',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        });
}

export async function getLeadership({commit, state}, id) {
    await $http.get(`/api/jefaturas/${id}`)
        .then((response) => {
            let leadership = response.data.data;
            commit('setLeadership', leadership);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/leadership/actions.js